module.exports = __webpack_public_path__ + "static/media/dropdown.0f1b1397.svg";